module.exports = __webpack_public_path__ + "static/media/ag.ff3d2dc2.png";